import KeyIcon from '@mui/icons-material/Key';
import { Avatar, Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { tr } from '../lib/i18n';
import { useAuth } from '../auth/AuthContext';
import { Button } from '../components/button';
import { ChangePasswordForm } from '../components/ProfileDialog';

/** Full-screen gate shown when the account must set a new password (created or reset by a manager). */
export function ForcePasswordPage() {
  const { me, logout } = useAuth();
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Card sx={{ width: '100%', maxWidth: 440 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <Avatar sx={{ bgcolor: 'warning.main', width: 52, height: 52 }}><KeyIcon /></Avatar>
            <Typography variant="h6">{tr('مرحباً', 'Welcome')}, {me?.user.full_name}</Typography>
          </Stack>
          <ChangePasswordForm />
          <Button fullWidth sx={{ mt: 1 }} onClick={() => void logout()}>{tr('تسجيل الخروج', 'Sign out')}</Button>
        </CardContent>
      </Card>
    </Box>
  );
}
